import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/icons/apy-vision.svg'


const _hoisted_1 = { class: "w-fit h-fit group mt-6 flex items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  width: "32",
  height: "32",
  class: "mr-2 rounded-full transition group-hover:shadow-lg",
  src: _imports_0,
  alt: ""
}, null, -1)

import {
  TitleTokens,
  useApyVisionHelpers,
} from '@/composables/external/useApyVisionHelpers';
import { getAddressFromPoolId } from '@/lib/utils';

/**
 * TYPES
 */
type Props = {
  poolId: string;
  titleTokens: TitleTokens;
};

/**
 * PROPS & EMITS
 */

export default _defineComponent({
  props: {
    poolId: { type: String, required: true },
    titleTokens: { type: null, required: true }
  } as unknown as undefined,
  setup(__props: {
  poolId: string;
  titleTokens: TitleTokens;
}) {



/**
 * COMPOSABLES
 */
const { poolPathSymbolSegment, apyVisionNetworkName } = useApyVisionHelpers();

return (_ctx: any,_cache: any) => {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalLink = _resolveComponent("BalLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BalLink, {
      href: 
        'https://app.apy.vision/pools/balancerv2_' +
        _unref(apyVisionNetworkName) +
        '-' +
        _unref(poolPathSymbolSegment)(__props.titleTokens) +
        '-' +
        _unref(getAddressFromPoolId)(__props.poolId)
      ,
      external: "",
      noStyle: "",
      class: "link link-black flex items-center font-medium"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('apyvisionPoolInsights')) + " ", 1),
        _createVNode(_component_BalIcon, {
          name: "arrow-up-right",
          size: "sm",
          class: "ml-0.5 text-gray-500 transition-colors hover:text-blue-400 group-hover:text-blue-500"
        })
      ]),
      _: 1
    }, 8, ["href"])
  ]))
}
}

})